import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "../utils/api";
import useAuthStore from "../store/authStore";

export default function AuthVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const setAuth = useAuthStore((s) => s.setAuth);

  // Guard gegen doppeltes Ausführen im StrictMode
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = params.get("token");
    if (!token) {
      toast.error("Fehlender Token");
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        // Passe den Pfad an DEIN Backend an (du nutzt /auth/verify-token)
        const { data } = await api.post("/auth/verify-token", { token });

        if (!data?.access_token || !data?.refresh_token || !data?.user) {
          throw new Error("Ungültige Server-Antwort");
        }

        // Persist + Auth setzen
        setAuth(data.user, data.access_token, data.refresh_token);

        toast.success("Eingeloggt 🎉");

        // Invite-Code mitgeben, damit wir direkt in den Join-Flow springen können
        const inviteCode = params.get("inviteCode");

        // Optional: zurück zur ursprünglichen Seite, falls über state gesetzt
        const from =
          (location.state &&
            location.state.from &&
            location.state.from.pathname) ||
          (inviteCode ? `/join/${inviteCode}` : "/");

        // URL aufräumen (kein ?token mehr)
        navigate(from, { replace: true });
      } catch (err) {
        console.error("Verify failed:", err);
        toast.error("Verifizierung fehlgeschlagen");
        navigate("/", { replace: true });
      }
    })();
  }, [params, navigate, setAuth, location.state]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-xl">Verifiziere…</div>
    </div>
  );
}
